import Route from 'mewe/routes/route';
import { inject as service } from '@ember/service';
import { fetchBookmarks } from 'mewe/fetchers/fetch-bookmarks';
import { ds } from 'mewe/stores/ds';

export default class BookmarksRoute extends Route {
  @service account;
  @service router;

  beforeModel() {
    const params = this.paramsFor('app.publicid');
    if (params.id !== this.account.activeUser.profileId) {
      this.router.transitionTo('app.publicid.posts', params.id);
    } else {
      fetchBookmarks();
    }
  }

  model() {
    return {
      app: this.modelFor('app'),
      bookmarks: ds.bookmarks,
    };
  }
}
